import { Fragment, useState } from "react";
import MainViewContent from "./MainViewContent";
import { formatSet, groupSetsBySession } from "./workoutUtils";

const MAIN_VIEW_CONTENT_COUNT = 3;
const MAIN_VIEW_CONTENT_VARIANTS = [
  "main-view-content-slot--blue",
  "main-view-content-slot--green",
  "main-view-content-slot--amber",
];

const buildCopyText = (workouts, goalText) => {
  const lines = [];
  if (goalText) {
    lines.push("【目標】");
    lines.push(goalText.trim());
    lines.push("");
  }
  workouts.forEach((workout) => {
    lines.push(`◆ ${workout.name}`);
    const history = groupSetsBySession(workout.sets);
    if (!history || history.length === 0) {
      lines.push("  履歴なし");
    } else {
      history.forEach((entry) => {
        const date = new Date(entry.timestamp);
        const dateLabel = Number.isNaN(date.getTime())
          ? entry.timestamp
          : date.toLocaleString();
        lines.push(`  - ${dateLabel}`);
        entry.sets.forEach((set, index) => {
          lines.push(`    Set${index + 1}: ${formatSet(set)}`);
        });
      });
    }
    lines.push("");
  });
  const text = lines.join("\n").trim();
  return text || "記録がまだありません。";
};

function MainView({
  workouts,
  goalText,
  onNavigateGoals,
  onLogout,
  onCreateWorkout,
  onAddSet,
  onDeleteSet,
  onUpdateGraphType,
  isLoading,
  errorMessage,
}) {
  const [copyStatus, setCopyStatus] = useState("idle");
  const handleCopy = async () => {
    const text = buildCopyText(workouts, goalText);
    try {
      if (typeof navigator !== "undefined" && navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(text);
        setCopyStatus("copied");
      } else {
        throw new Error("Clipboard API not available");
      }
    } catch (error) {
      try {
        const textarea = document.createElement("textarea");
        textarea.value = text;
        textarea.setAttribute("readonly", "");
        textarea.style.position = "absolute";
        textarea.style.left = "-9999px";
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand("copy");
        document.body.removeChild(textarea);
        setCopyStatus("copied");
      } catch (fallbackError) {
        console.error("Failed to copy workout summary", fallbackError);
        setCopyStatus("copy-error");
      }
    }
    setTimeout(() => setCopyStatus("idle"), 2000);
  };

  const contentProps = {
    workouts,
    isLoading,
    errorMessage,
    onCreateWorkout,
    onAddSet,
    onDeleteSet,
    onUpdateGraphType,
    copyStatus,
  };

  return (
    <div className="page-card main-page-card">
      <header className="page-header">
        <h1 className="page-title">筋トレ管理</h1>
        <div className="header-actions">
          <button
            className="link-button"
            type="button"
            onClick={onNavigateGoals}
          >
            目標を編集
          </button>
          <button
            className="secondary-button"
            type="button"
            onClick={handleCopy}
          >
            copy
          </button>
          <button className="link-button" type="button" onClick={onLogout}>
            ログアウト
          </button>
        </div>
      </header>
      {Array.from({ length: MAIN_VIEW_CONTENT_COUNT }, (_, index) => (
        <Fragment key={index}>
          <div
            className={`main-view-content-slot ${
              MAIN_VIEW_CONTENT_VARIANTS[
                index % MAIN_VIEW_CONTENT_VARIANTS.length
              ]
            }`}
          >
            <MainViewContent {...contentProps} />
          </div>
          {index < MAIN_VIEW_CONTENT_COUNT - 1 ? (
            <hr className="divider" />
          ) : null}
        </Fragment>
      ))}
    </div>
  );
}

export default MainView;
